import { FC, HTMLProps } from 'react'
import { cn } from '@/lib/utils'

interface ButtonYearProps extends HTMLProps<HTMLDivElement> {
	isSelected: boolean
}

export const ButtonYear: FC<ButtonYearProps> = ({ isSelected, ...rest }) => {
	const customShadowClass = 'shadow-[0px_4px_6px_0px_rgba(0,_0,_0,_0.1)]'

	return (
		<div
			{...rest}
			className={cn(
				'p-3.5 border-2 border-solid rounded-[12px] relative',
				isSelected ? 'border-[#DCF831]' : `border-transparent ${customShadowClass}`,
				rest.className
			)}>
			<p className={'text-[13px] text-[#4D4F50]'}>Годовой</p>
			<p className={'font-bold text-[22px] '}>4 920,00 ₽</p>
			<p className={'text-[12px] text-[#4D4F50]'}>В год</p>
			<div
				className={
					'absolute py-1 px-2.5 top-[-13px] shadow-md rounded-full bg-[#CBDDF5] text-[10px]'
				}>
				Сэкономьте 2 760,00 ₽
			</div>
		</div>
	)
}
